module.exports = __webpack_public_path__ + "img/sebastian-hagens-3@2x.e52d3164.jpg";